import React, { FC } from 'react';
import { SWRConfig } from 'swr';
import { parseErrorMessage } from '@/lib/api/config';
import { getAuthTokenClient } from '@/utils/helpers';

declare global {
  interface Window {
    yotpo?: any;
    trustbadge?: any;
  }
}

export interface LoveverySWRConfigInterface {
  children: React.ReactNode;
}

async function fetcher(uri: string): Promise<JSON> {
  const defaultConfig = {
    headers: {
      Authorization: await getAuthTokenClient(),
    },
  };

  const response = await fetch(uri, { ...defaultConfig });

  // by default fetch doesn't throw an error even if we receive a non 2xx status code
  // we need to throw an error for useSWR to catch and set the error object in our requests
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response));
  }

  return await response.json();
}

const LoveverySWRConfig: FC<LoveverySWRConfigInterface> = ({ children }) => {
  return (
    <SWRConfig value={{ fetcher }}>
      <>{children}</>
    </SWRConfig>
  );
};

export default React.memo(LoveverySWRConfig);
